﻿/*
Leadsraiser common script
*/

(function (document, window, $, lr, undefined) {
    window.lr__ready = window.lr__ready || [];
    lr.session = lr.session || {}; // must be set by site script

    if (!Array.isArray) {
        Array.isArray = function (arg) {
            return Object.prototype.toString.call(arg) === '[object Array]';
        };
    }

    function unwrapDeferredPromise(mayBePromise) {
        if (mayBePromise instanceof Promise) {
            return mayBePromise.deferredPromise;
        }

        return mayBePromise;
    }

    // Promises
    var Promise = window.Promise;
    if (!Promise) {
        // polifyll with jQuery deffered
        Promise = function (initializeCallback) {
            if (!initializeCallback)
                throw new Error('Invalid initialization callback');

            var $deferred = $.Deferred();

            try {
                initializeCallback(function (data) {
					 $.when(unwrapDeferredPromise(data)).then($deferred.resolve, $deferred.reject);
				}, function (reason) { 
					$.when(unwrapDeferredPromise(reason)).then($deferred.reject, $deferred.reject);
				});
            } catch (e) {
                $deferred.reject(e);
            }

            this.deferredPromise = $deferred.promise();
        };

        Promise.reject = function (reason) {
            return new Promise(function (resolve, reject) {
                reject(reason);
            });
        };

        Promise.resolve = function (data) {
            return new Promise(function (resolve, reject) {
                resolve(data);
            });
        };

        Promise.prototype.then = function (successCallback, failCallback) {
            var basePromise = this.deferredPromise;

            function wrapCallback(callback) {
                if (!callback)
                    return null;

                return function (data) {
                    try {
                        return $.when(unwrapDeferredPromise(callback(data)));
                    } catch (e) {
                        return unwrapDeferredPromise(Promise.reject(e));
                    }
                };
            }

            return new Promise(function (resolve, reject) {
                basePromise.then(wrapCallback(successCallback), wrapCallback(failCallback)).then(resolve, reject);
            });
        };

        Promise.prototype['catch'] = function (failCallback) {
            return this.then(null, failCallback);
        };

        Promise.all = function (promises) {
            if (!Array.isArray(promises)) {
                throw new Error('Argument must be an array');
            }

            var deferredPromises = [];
            for (var i = 0; i < promises.length; i++) {
                deferredPromises.push(unwrapDeferredPromise(promises[i]));
            }

            return new Promise(function (resolve, reject) {
                $.when.apply($, deferredPromises).then(function () {
                    resolve(Array.prototype.slice.call(arguments));
                }, reject);
            });
        };

        Promise.race = function (promises) {
            if (!Array.isArray(promises))
                throw new Error('Argument must be an array');

            return new Promise(function (resolve, reject) {
                for (var i = 0, promise; i < promises.length; i++) {
                    promise = promises[i];

                    if (promise && typeof promise.then === 'function') {
                        promise.then(resolve, reject);
                    } else {
                        resolve(promise);
                    }
                }
            });
        };

        window.Promise = Promise;
    }

    if (!Promise.prototype.fail) {
        Promise.prototype.fail = Promise.prototype['catch'];
    }

    if (!Promise.delay) {
        Promise.delay = function (delay) {
            return new Promise(function (resolve, reject) {
                setTimeout(resolve, delay);
            });
        };
    }

    // main object
    $.extend(lr, {
        Promise: Promise,
        replaceAll: function (str, parameters, encodeParameters) {
            encodeParameters = encodeParameters || false;

            if (parameters != null) {
                for (var key in parameters) {
                    if (parameters.hasOwnProperty(key)) {
                        str = str.replace('{' + key.toUpperCase() + '}', encodeParameters ? encodeURIComponent(parameters[key]) : parameters[key]);
                    }
                }
            }

            return str;
        },
        openWindow: function (url, name, winParameters) {
            var parameters = winParameters || 'fullscreen=yes,scrollbars=yes,location=no,menubar=no,resizeable=yes,status=no,toolbar=yes';

            window.open(url, name || ('SA' + Math.random()), parameters);
        },
        onClose: {
            disable: function () {
                window.blnShowPP = 0;
                if (window.LastVisionScript) {
                    window.LastVisionScript.enabled = false;
                }
            },
            enable: function () {
                window.blnShowPP = 1;
                if (window.LastVisionScript) {
                    window.LastVisionScript.enabled = true;
                }
            }
        },
        support: {
            touch: !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch || navigator.msMaxTouchPoints),
            history: !!(window.history && window.history.pushState),
            transitions: (function () {
                var thisBody = document.body || document.documentElement;
                var thisStyle = thisBody.style;
                var support = thisStyle.transition !== undefined || thisStyle.WebkitTransition !== undefined || thisStyle.MozTransition !== undefined || thisStyle.MsTransition !== undefined || thisStyle.OTransition !== undefined;
                return support;
            })(),
            json: !!window.JSON
        },
        api: {
            callServerMethod: function (method, parameters, settings) {
                var s = settings || {};
                return new Promise(function (resolve, reject) {
                    $.ajax('/ca/' + method, {
                        data: $.extend({}, parameters, {
                        	currentPageUrl: lr.session.currentPageUrl,
							pageActionId: lr.session.pageActionId
                        }),
                        dataType: 'json',
                        type: s.requestType || 'GET',
                        traditional: true
                    }).then(resolve, reject);
                }).then(function (response) {
                    if (response.status === "ok") {
                        return Promise.resolve(response.data);
                    } else {
                        return Promise.reject(response.data);
                    }
                });
            },
            get: function (method, parameters, settings) {
                return lr.api.callServerMethod(method, parameters, $.extend({}, settings, {
                    requestType: 'GET'
                }));
            },
            post: function (method, parameters, settings) {
                return lr.api.callServerMethod(method, parameters, $.extend({}, settings, {
                    requestType: 'POST'
                }));
            },
            getPixels: function (onlyNew) {
                return lr.api.get('GetPixels', {
                    onlyNew: onlyNew
                });
            },
            appendNewPixels: function () {
                return lr.api.appendPixels(true);
            },
            appendPixels: function (onlyNew) {
                return lr.api.getPixels(!!onlyNew).then(function (data) {
                    if (data) {
                        if (data.head) {
                            $('head').append(data.head);
                        }
                        if (data.bodyStart) {
                            $('body').prepend(data.bodyStart);
                        }
                        if (data.bodyEnd) {
                            $('body').append(data.bodyEnd);
                        }
                    }

                    return data;
                });
            },
            trackStepShow: function (stepNumber) {
                return lr.api.post('TrackStepShow', {
                    stepNumber: stepNumber
                });
            },
            trackStepTransition: function (stepNumber, newStepNumber) {
                return lr.api.post('TrackStepTransition', {
                    stepNumber: stepNumber,
                    newStepNumber: newStepNumber
                });
            },
            registerError: function (message, stack, data) {
                data = $.extend({}, { sessionData: lr.session, request: window.location.href }, data);
                var stringData = '';
                if (lr.support.json) {
                    try {
                        stringData = JSON.stringify(data);
                    } catch (e) {
                    }
                }

                return lr.api.post('RegisterError', {
                    message: message,
                    stack: stack,
                    data: stringData
                });
            },
            registerException: function (error, data) {
                var clientData = $.extend({}, { exceptionType: error.name, exceptionMessage: error.message }, data);
                return lr.api.registerError(error.name + ': ' + error.message, error.stack, clientData);
            },
            validateStateByZip: function (zip, state) {
                return lr.api.get('ValidateStateByZip', {
                    zip: zip,
                    state: state
                });
            },
            saveClientParameters: function () {
                var currentDate = new Date();
                var currentTimeZoneOffsetInHours = (currentDate.getTimezoneOffset() / 60) * (-1);
                return lr.api.post('SaveClientParameters', {
                    timeZone: currentTimeZoneOffsetInHours,
                    screenWidth: window.screen.width,
                    screenHeight: window.screen.height,
                    touchSupport: lr.support.touch,
                    loadTime: lr.pagespeed_start ? Number(new Date()) - lr.pagespeed_start : 0,
                    hash: window.location.hash,
                    clientTime: new Date().toString()
                });
            },
            raiseControlActions: function (controlId, actions, parameters) {
                return lr.api.post('RaiseControlActions', $.extend({}, parameters, {
                    controlId: controlId,
                    actions: actions
                })).then(function (data) {
                    if (!data.success) {
                        return Promise.reject(data.errors);
                    } else {
                        return Promise.resolve();
                    }
                });
            }
        },
        executeSafe: function (callback) {
            if (typeof callback == "function") {
                try {
                    callback();
                } catch (e) {
                    lr.api.registerException(e);
                }
            }
        },
        onload: function ($context) {
            lr.executeSafe(function () {
                if (!lr.session.scriptTracked) {
                    lr.api.saveClientParameters();
                }
            });
        },
        init: function ($context) {
            lr.executeSafe(function () {
                try {
                    $('.adv, .adsense, iframe, button, a, input[type=submit], input[type=image], input[type=button]', $context)
                        .mouseenter(function () {
                            lr.onClose.disable();
                        }).mouseleave(function () {
                            lr.onClose.enable();
                        }).focus(function () {
                            lr.onClose.disable();
                        }).blur(function () {
                            lr.onClose.enable();
                        });
                } catch (e) {
                    // some bugs in jquery - not matter
                }

                if (lr.support.touch) {
                    $('.hidden-touch', $context).hide();
                    $('.visible-touch', $context).show();
                } else {
                    $('.hidden-touch', $context).show();
                    $('.visible-touch', $context).hide();
                }

                $('.separated-phone', $context).each(function (index, el) {
                    var $el = $(el);
                    var $phone = $el.find('input.phone');
                    var $phoneParts = $el.find('input:not(.phone)');
                    var $areaCode = $phoneParts.filter('.area-code');
                    var $prefix = $phoneParts.filter('.prefix');
                    var $postfix = $phoneParts.filter('.postfix');

                    function phonePartChange() {
                        $phone.val($areaCode.val() + $prefix.val() + $postfix.val());

                        var phone = $phone[0];

                        if (typeof $.fn.validate == "function") {
                            var validator = $(phone.form).validate();
                            if (phone.name in validator.submitted) {
                                validator.element(phone);
                            }
                        }
                    }

                    function parsePhone() {
                        var phoneVal = $phone.val();
                        if (phoneVal != null) {
                            $areaCode.val(phoneVal.substring(0, 3));
                            $prefix.val(phoneVal.substring(3, 6));
                            $postfix.val(phoneVal.substring(6, 10));
                        }
                    }

                    $phone.change(function () {
                        parsePhone();
                    });
                    parsePhone();

                    $phoneParts.change(function () {
                        phonePartChange();
                    }).blur(function () {
                        phonePartChange();
                    });

                    if (typeof $.fn.autotab_magic == "function") {
                        $phoneParts.autotab_magic().autotab_filter('numeric');
                    }
                });
            });
        }
    });

    String.prototype.replaceAll = function (parameters, encodeParameters) {
        return lr.replaceAll(this, parameters, encodeParameters);
    };

    function onload() {
        lr.onload(document);
    }

    var f = window.addEventListener;
    if (f) {
        f('load', onload, false);
    } else {
        f = window.attachEvent;
        if (f) {
            f('onload', onload);
        }
    }

    lr__ready.push(function () {
        lr.init(document);
    });

    $(function () {
        for (var i = 0; i < lr__ready.length; i++) {
            lr__ready[i]();
        }
    });
})(document, window, jQuery, window.lr = window.lr || {});
